import { ProductBuilderMachineState } from '../../types';

type StateMap = {
  [key in ProductBuilderMachineState]: string;
};

export const stateMap: StateMap = {
  bottomRailColour: 'Bottom rail colour',
  bracketColour: 'Bracket colour',
  componentsColour: 'Components colour',
  bottomBarColour: 'Bottom bar colour',
  cellDesign: 'Cell design',
  chainColour: 'Chain colour',
  chainPosition: 'Chain position',
  chainRelease: 'Chain release',
  chainType: 'Chain type',
  colour: 'Colour',
  colourDay: 'Colour - Day',
  colourNight: 'Colour - Night',
  commonValance: 'Common valance',
  complete: 'Complete',
  configuration: 'Configuration',
  cordPosition: 'Cord position',
  dayColour: 'Colour - Day',
  dayFabricPosition: 'Day fabric position',
  designerTape: 'Designer tape',
  driveControl: 'Drive control',
  extensionPole: 'Extension pole',
  fitting: 'Fitting',
  holdDownBrackets: 'Hold down brackets',
  idle: 'Idle',
  liftPosition: 'Lift position',
  lightGuards: 'Light guards',
  lining: 'Lining',
  liningColour: 'Lining colour',
  liningStyle: 'Lining style',
  materialType: 'Material type',
  materialTypeDay: 'Material type - Day',
  materialTypeNight: 'Material type - Night',
  measureInsurance: 'Measure insurance',
  measurements: 'Measurements',
  mountingSurface: 'Mounting surface',
  pleatType: 'Pleat type',
  pleatFinish: 'Pleat finish',
  transparency: 'Transparency',
  powerSupply: 'Power supply',
  railColour: 'Rail colour',
  remoteControl: 'Remote control',
  rollDirection: 'Roll direction',
  roomName: 'Room name',
  shipping: 'Shipping',
  slatSize: 'Slat size',
  stackSide: 'Stack side',
  tiltControl: 'Tilt control',
  tiltPosition: 'Tilt Position',
  track: 'Track',
  trackRequire: 'Track requirement',
  trackColour: 'Track colour',
  pullRod: 'Pull rod',
  pullRodColour: 'Pullrod colour',
  wifiHub: 'WIFI hub',
  frameStyle: 'Frame Style',
  numberOfPanels: 'Number of Panels',
  panelConfiguration: 'Panel Configuration',
  bladeSize: 'Blade Size',
  operation: 'Operation Variant',
  dynamicPrice: 'Price',
  smartRelease: 'Smart Release',
  fascia: 'Fascia',
  venetianValance: 'Venetian Valance',
  totalPrice: 'Price',
  smartReleasePrice: 'Price',
  lightGuardPrice: 'Price',
  venetianValancePrice: 'Price',
  trackPrice: 'Price',
  fasciaPrice: 'Price',
  extensionPolePrice: 'Price',
  measureInsurancePrice: 'Price',
  honeycombVerticalCentreOpeningSurcharge:
    'Honeycomb Vertical Centre Opening Surcharge',
  honeycombVerticalCentreOpeningSurchargePrice: 'Price',
  stainlessSteelChain: 'Stainless Steel Chain',
  stainlessSteelChainPrice: 'Price',
  ceilingMountPleatedCurtainRail: 'Curtain Rail',
  faceMountPleatedCurtainRail: 'Curtain Rail',
  ceilingMountWaveFoldCurtainRail: 'Curtain Rail',
  faceMountWaveFoldCurtainRail: 'Curtain Rail',
  ceilingMountPleatedCurtainDoubleRail: 'Curtain Rail',
  faceMountPleatedCurtainDoubleRail: 'Curtain Rail',
  ceilingMountWaveFoldCurtainDoubleRail: 'Curtain Rail',
  faceMountWaveFoldCurtainDoubleRail: 'Curtain Rail',
  wand_option:"Wand option",
  wand_colour:"Wand colour",
  wand_colour_price:"Price",
  wand_colour_variant_id:"",
  track_colour_variant_id:"",
  track_colour_price:"Price",
  lining_colour_variant_id:"",
  lining_colour_price:"Price"
};

export const allStates = Object.keys(stateMap) as ProductBuilderMachineState[];
